exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display-wrapper {\n\tpadding: 0 10px;\n}\n\n.display-wrapper .display-body {\n\tmax-height: 300px;\n\toverflow: auto;\n}\n\n.display-wrapper .home-heading,\n.display-wrapper .next-btn-wrap {\n\tpadding: 10px 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/display-modal/display-modal.component.css
// module id = ../../../../../src/app/modals/display-modal/display-modal.component.css
// module chunks = main